/* eslint-disable no-unused-vars */
import { cloneDeep } from 'lodash';
import oidcConfig from './oidc.config';
import { attachmentCategory, attachmentDetections } from './enum';
import Tafqeet from '@/plugins/tafqeet';
import moment from 'moment-hijri';

export const isLocalDevelopment = () => process.env.NODE_ENV === 'local';
export const isDevelopment = () => process.env.NODE_ENV === 'development';

export const uuidGenerator = () =>
  'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });

export const deepClone = object => (object ? cloneDeep(object) : null);

export const stringToKebabCase = (str) => {
  if (!str) return null;
  const strReplaced = str.toString()
    .replace(/\.| |:|\|/g, '-');
  return strReplaced
    .replace(/(?!^)[A-Z]/g, '-$&')
    .replace(/^-/, '')
    .replace(/-\s*$/, '')
    .replaceAll('(', '')
    .replaceAll(')', '')
    .toLowerCase();
};

export const generateHtmlTagId = (elem, prefix) => {
  const id = [prefix];

  // id.push(stringToKebabCase(((elem.$parent.$el || {}).classList || {}).value));
  // id.push(stringToKebabCase(((elem.$el || {}).classList || {}).value));
  id.push(stringToKebabCase(elem.$parent.title));
  id.push(stringToKebabCase(elem.title));
  id.push(stringToKebabCase(elem.$attrs.label));

  const technicalName = elem.$attrs['technical-name'];
  technicalName && id.push(stringToKebabCase(technicalName));

  if (elem.$slots.default && elem.$slots.default.length) {
    id.push(stringToKebabCase(elem.$slots.default[0].text));
  }

  return id.filter(x => !!x)
    .join('-');
};

export const convertToValidTechnicalName = str => (str || '').replace(/[^a-z0-9_]/gi, '');

export const getCookie = (name) => {
  const v = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`);
  return v ? v[2] : null;
};

const getLocalStorageParsedItem = (key) => {
  const item = localStorage.getItem(key);
  return JSON.parse(item);
};

export const isAuthenticated = () => {
  const savedUser = getLocalStorageParsedItem(
    `oidc.user:${oidcConfig.authority}:${oidcConfig.client_id}`
  );
  const isExpired = !savedUser || savedUser.expires_at < Date.now() / 1000;

  return Boolean(savedUser) && Boolean(savedUser.access_token) && !isExpired;
};

export const getAccessToken = () => {
  if (!isAuthenticated()) return;

  const savedUser = getLocalStorageParsedItem(
    `oidc.user:${oidcConfig.authority}:${oidcConfig.client_id}`
  );

  return `${savedUser.token_type} ${savedUser.access_token}`;
};

export const resetAccessToken = () => {
  localStorage.removeItem(
    `oidc.user:${oidcConfig.authority}:${oidcConfig.client_id}`
  );
};

export const convertToEnglish = (string) => {
  return string
    .replace(/[\u0660-\u0669]/g, c => c.charCodeAt(0) - 0x0660)
    .replace(/[\u06f0-\u06f9]/g, c => c.charCodeAt(0) - 0x06f0);
};

export const scrollIntoInValidInput = (errors) => {
  const firstInvalidField = Object.keys(errors.collect())[0];
  document
    .querySelector(`[id*='${firstInvalidField}']`)
    .parentElement.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
};

// @IMPORTANT: next obj param is used inside the eval expression (In run time).
// eslint-disable-next-line no-unused-vars
export const executeString = (expression, obj = {}) => {
  try {
    try {
      // eslint-disable-next-line no-eval
      return eval(expression);
    } catch {
      // eslint-disable-next-line no-eval
      return eval(`"${expression}"`);
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn(`Error: ${e}\nWhile executing script: ${expression}`);
    return null;
  }
};

export const printElementContent = (elementContent) => {
  let styleSheetList = '';
  document.getElementsByTagName('style')
    .forEach((styleElem) => {
      styleSheetList += styleElem.outerHTML;
    });
  const printWindow = window.open('', 'print-window', 'height=640,width=875');

  printWindow.document.write('<html dir="rtl">');
  printWindow.document.write(
    `<head><title>${document.title}</title>${styleSheetList}</head>`
  );
  printWindow.document.write(`<body>${elementContent}</body>`);
  printWindow.document.write('</html>');

  setTimeout(() => {
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  }, 500);
};

export const printPageByUrl = (url) => {
  window.open(url, 'print-window', 'height=640,width=875');
};

export const convertEnToArChar = (char) => {
  try {
    return ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'][+char];
  } catch (error) {
    return char;
  }
};

const modulePrefixes = {
  ADMINISTRATION: '/administration/api',
  CASES: '/cases/api',
  CASES_REQUESTS: '/CasesRequests/api',
  INBOX: '/inbox/api',
  REQUESTS: '/requests/api',
  SYSTEM: '/system/api',
  ICMS: '/icms/api',
  Bankruptcy: '/bankruptcy/api',
};

const localModulePrefixes = {
  ADMINISTRATION: 'https://localhost:44318/api',
  CASES: 'https://localhost:44390/api',
  CASES_REQUESTS: 'https://localhost:44390/api',
  INBOX: 'https://localhost:44399/api',
  REQUESTS: 'https://localhost:44311/api',
  SYSTEM: 'https://localhost:44328/api',
  ICMS: 'https://localhost:44304/api',
  Bankruptcy: 'http://localhost:60610/api',
};

export const apiModule = isLocalDevelopment()
  ? localModulePrefixes
  : modulePrefixes;

export const resetScroll = () => {
  setTimeout(() => {
    const appElement = document.getElementById('app');
    const contentBoxElement = document.querySelector('.content-box');

    if (appElement) {
      appElement.scrollTop = 0;
    }

    if (contentBoxElement) {
      contentBoxElement.scrollTop = 0;
    }
  });
};

export const isAttachmentDetected = (category, data) => {
  if (category === attachmentCategory.residence) {
    const isFound = data.find((item) => {
      return (
        item.detections[0] &&
        item.detections[0].class === attachmentDetections.residentId
      );
    });

    if (isFound) {
      return true;
    }

    return false;
  }

  if (
    category === attachmentCategory.prosecutorIdentity ||
    category === attachmentCategory.respondentIdentity ||
    category === attachmentCategory.agentIdentity ||
    category === attachmentCategory.attorneyIdentity
  ) {
    const isFound = data.find((item) => {
      if (
        item.detections[0] &&
        (item.detections[0].class === attachmentDetections.nationalId ||
          item.detections[0].class === attachmentDetections.nationalIdNew ||
          item.detections[0].class === attachmentDetections.nationalIdOld)
      ) {
        return true;
      }

      return false;
    });

    if (isFound) {
      return true;
    }

    return false;
  }

  return false;
};

export const convertNumberToText = number => Tafqeet(number);

export const isValidDate = date => isNaN(+date)
  && isNaN(Date.parse(date)) == false
  && !Array.isArray(date)
  && !/[\u0600-\u06FF]/.test(date);
export const isValidMiladyDate = date => isValidDate(date) && Date.parse(date) >= -3471300309000;
export const isValidHijriDate = date => isValidDate(date) && Date.parse(date) < -3471300309000;

const currentTime = () => Date.now();
const expiresAfter = currentTime() - process.env.VUE_APP_LOOKUPS_CACHING_SEC * 1000;

const encode = (value) => {
  if (isDevelopment() || isLocalDevelopment())
    return JSON.stringify(value);
  else
    return btoa(unescape(encodeURIComponent(JSON.stringify(value))));
};

const decode = (value) => {
  if (isDevelopment() || isLocalDevelopment())
    return JSON.parse(value);
  else
    return JSON.parse(decodeURIComponent(escape(atob(value))));
};

const $localStorage = {};
export const setInLocalStorage = (key, value) => {
  const object = {
    accessToken: getAccessToken(),
    dateTime: currentTime(),
    value: value,
  };
  $localStorage[`naj-${key}`] = encode(object);
  setTimeout(async () => {
    try {
      localStorage.setItem(encode(`naj-${key}`), encode(object));
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log('Local Storage error: ', err);
    }
  }, 0);
};
export const getFromLocalStorage = (key, defaultValue) => {
  const item = $localStorage[`naj-${key}`] || localStorage.getItem(encode(`naj-${key}`));
  if (item) {
    try {
      const object = decode(item);
      if (object.accessToken !== getAccessToken() || object.dateTime < expiresAfter) {
        throw new Error();
      } else {
        $localStorage[`naj-${key}`] = item;
        return object.value;
      }
    } catch (e) {
      $localStorage[`naj-${key}`] = undefined;
      localStorage.removeItem(encode(`naj-${key}`));
      return defaultValue;
    }
  } else {
    return defaultValue;
  }
};

export const getDayArabicName = (date) => {
  if (!date) {
    return '';
  }
  const currentLocale = moment;
  currentLocale.locale('ar');
  var dt = currentLocale(date, 'YYYY-MM-DD HH:mm:ss');
  return dt.format('dddd');
};

export const getDayMonthHijri = (date) => {
  if (!date) {
    return '';
  }
  const currentLocale = moment;
  currentLocale.locale('ar-SA');
  const hijriDate = currentLocale(date)
    .format('iD iMMMM');
  return hijriDate;
};

export const getTimePartArabic = (date) => {
  if (!date) {
    return '';
  }
  const currentLocale = moment;
  currentLocale.locale('ar-SA');
  var dt = currentLocale(date, 'YYYY-MM-DD HH:mm:ss');
  return dt.format('HH:mm A');
};

export const getTimePart = (date) => {
  const currentLocale = moment.locale();
  moment.locale('en');
  const timeString = moment(date).format('HH:mm A');
  moment.locale(currentLocale);
  return timeString;
};

export const getTime12Format = (date) => {
  const currentLocale = moment.locale();
  moment.locale('en');
  const timeString = date ? moment(date).format('hh:mm') : '';
  moment.locale(currentLocale);
  return timeString;
};

export const getTimeSlot = (startDate, endDate) => {
  const currentLocale = moment.locale();
  moment.locale('en');
  const startTimeString = startDate ? moment(startDate).format('hh:mm') : '';
  const endTimeString = endDate ? moment(endDate).format('hh:mm') : '';
  moment.locale(currentLocale);
  return startTimeString + '-' + endTimeString;
};

export const isAm = (date) => {
  return moment(date).locale('en').format('A') == 'AM';
};

export const getDateObj = (startDateString, starTimeString) => {
  const currentLocale = moment.locale();
  moment.locale('en');
  const startDateMoment = moment(startDateString + 'T' + starTimeString);
  moment.locale(currentLocale);

  return {
    start: startDateMoment.toDate(),
    end: startDateMoment.add(1, 'hours').toDate(),
  };
};

/*
  if time in form of 08:00 return 08 else return the same time
*/
const removeZeros = (time) => {
  if (time && time.endsWith(':00')) {
    time = time.slice(0, -3);
  }
  return time;
};

export const getDateDifference = (date) => {
  if (!date) {
    return -1;
  }
  var now = moment(moment(new Date()).format('YYYY-MM-DD')); //todays date
  var end = moment(moment(date).format('YYYY-MM-DD')); // another date
  return end.diff(now, 'days');
};

export const getHoursDifference = (date) => {
  if (!date) {
    return -1;
  }
  var now = moment(moment(new Date()).format('YYYY-MM-DD HH:mm:ss')); //todays date
  var end = moment(moment(date).format('YYYY-MM-DD HH:mm:ss')); //another date
  return now.diff(end, 'hour');
};

export const getTwoDatesDifference = (startDate, endDate) => {
  if (!startDate) {
    return -1;
  }
  var now = moment(moment(endDate).format('YYYY-MM-DD')); //todays date
  var end = moment(moment(startDate).format('YYYY-MM-DD')); // another date
  return end.diff(now, 'days');
};

export const toHijriDate = (date) => {
  if (!date) return '';
  const hijriDate = moment(date).format('iYYYY/iMM/iDD');
  const gregorianDate = moment(date).format('YYYY/MM/DD مـ');
  return hijriDate.includes('NaN') ? gregorianDate : hijriDate;
};

export const toGeorgianDateString = (date) => {
  const dt = toLocalDate(date);
  return dt ? dt.format('YYYY/MM/D') : '';
};

export const toLocalDate = (date) => {
  if (!date) {
    return '';
  }
  const currentLocale = moment.locale();
  moment.locale('en-SA');
  const timeString = moment(date, 'YYYY-MM-DD HH:mm:ss');
  moment.locale(currentLocale);
  return timeString;
};

export const formatDateString = (date, formatString = 'iYYYY/iMM/iDD - hh:mm a') => {
  if (!date) {
    return '';
  }
  return moment(date).format(formatString);
};

export const formatGeorgianEnDateString = (date, inputDateFormat = 'YYYY-MM-DD HH:mm:ss', outputDateFormat = 'YYYY/MM/D') => {
  if (!date) {
    return '';
  }
  const currentLocale = moment;
  currentLocale.locale('en-SA');
  const dt = currentLocale(date, inputDateFormat);
  return dt.format(outputDateFormat);
};

export const truncateText = (text, stop = 27, clamp = '...') => {
  return text && text.slice(0, stop) + (stop < text.length ? clamp || '...' : '');
};

export const getBlobUrl = (base64Data, isImage) => {
  if (!base64Data) return null;
  const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  };
  base64Data = base64Data.replace(/^data:.+;base64,/, '');
  const blob = b64toBlob(base64Data, detectMimeType(base64Data) || 'image/png');
  return URL.createObjectURL(blob);
};

export const detectMimeType = (b64) => {
  for (var s in signatures) {
    if (b64.indexOf(s) === 0) {
      return signatures[s];
    }
  }
};

const signatures = { JVBERi0: 'application/pdf' };